// Development
const API_DOMAIN_DEV_URL = "https://be.dev.jaibharatconst.com";
// .env.production
export const API_DOMAIN_ENV_URL = process.env.REACT_APP_BE_URL;

const API_DOMAIN = API_DOMAIN_ENV_URL || API_DOMAIN_DEV_URL;

export const BASE_BACKEND_URL = `${API_DOMAIN}/api`;
export const BASE_IMAGE_URL =
  "https://jai-bharat-dev.s3.ap-south-1.amazonaws.com/";

// API list
export const PAYLOAD = "/auth/payload";
export const LOGIN_URL = BASE_BACKEND_URL + "/authenticate";
export const CHANGE_PASSWORD = BASE_BACKEND_URL + "/user/change/password";
export const RESET_PASSWORD = BASE_BACKEND_URL + "/user/password/update";
export const UUID_URL = BASE_BACKEND_URL + "/uuid";
export const GET_USER = BASE_BACKEND_URL + "/user/";

// Expense Module API
export const ALL_EXPENSES = BASE_BACKEND_URL + "/expense/all";
export const EXPENSE_SETUP = BASE_BACKEND_URL + "/expense/setup";
export const EXPENSE_PENDING_RECEIVER =
  BASE_BACKEND_URL + "/expense/pending/receiver";
export const EXPENSE_PENDING_SUPERVISOR =
  BASE_BACKEND_URL + "/expense/pending/supervisor";
export const EXPENSE_PENDING_ADMIN =
  BASE_BACKEND_URL + "/expense/pending/admin";
export const EXPENSE_PENDING_SUPER_ADMIN =
  BASE_BACKEND_URL + "/expense/pending/super-admin";
export const CHECK_RECEIVER_EXPENSE =
  BASE_BACKEND_URL + "/expense/check/receiver";
export const CHECK_SUPERVISOR_EXPENSE =
  BASE_BACKEND_URL + "/expense/check/supervisor";
export const CHECK_ADMIN_EXPENSE = BASE_BACKEND_URL + "/expense/check/admin";
export const CHECK_SUPER_ADMIN_EXPENSE =
  BASE_BACKEND_URL + "/expense/check/super-admin";
export const EXPENSE_CHECK_HISTORY =
  BASE_BACKEND_URL + "/expense/check/history";
export const EXPENSE_HISTORY = BASE_BACKEND_URL + "/expense/history/";
export const ADD_LOAN = BASE_BACKEND_URL + "/expense/loan";
export const LOAN_SETUP = BASE_BACKEND_URL + "/expense/loan/setup";
export const LOAN_History = BASE_BACKEND_URL + "/expense/loan/history";
export const EXPENSE_REMARK = BASE_BACKEND_URL + "/expense/remark";
export const ADD_OVERTIME_SETUP = BASE_BACKEND_URL + "/expense/overtime-setup";
export const Add_EXPENSE = BASE_BACKEND_URL + "/expense";

//complaint Module API
export const ALL_COMPLAINT = BASE_BACKEND_URL + "/complaint/all";
export const COMPLAINT_SETUP = BASE_BACKEND_URL + "/complaint/setup";
export const VISIT_SETUP = BASE_BACKEND_URL + "/visit/setup";
export const ADD_COMPLAINT = BASE_BACKEND_URL + "/complaint";
export const ADD_VISIT = BASE_BACKEND_URL + "/visit";
export const GET_CYLINDERS = BASE_BACKEND_URL + "/cylinder/station/";
export const ALL_SITE = BASE_BACKEND_URL + "/station/all";
export const ALL_SITE_BY_USER = BASE_BACKEND_URL + "/station/all-byuser";
export const ADD_OPERATOR = BASE_BACKEND_URL + "/station/operator";
export const COMPLAINT_CHECK = BASE_BACKEND_URL + "/complaint/check";
export const VISIT_CHECK = BASE_BACKEND_URL + "/visit/check";
export const VISIT_PENDING = BASE_BACKEND_URL + "/visit/check/pending";
export const VISIT_HISTORY = BASE_BACKEND_URL + "/visit/history/";
export const COMPLAINT_PENDING = BASE_BACKEND_URL + "/complaint/check/pending";
export const COMPLAINT_REMARK = BASE_BACKEND_URL + "/complaint/remark";
export const VISIT_REMARK = BASE_BACKEND_URL + "/visit/remark";
export const DELETE_SITE_OPERATOR = BASE_BACKEND_URL + "/station/operator/";
export const CYLINDER_SETUP = BASE_BACKEND_URL + "/cylinder/history/setup"
export const VISIT_PDF = BASE_BACKEND_URL + "/visit/"

// Expense Sheet API
export const UPLOAD_SHEET = BASE_BACKEND_URL + "/expense/sheet/upload";
export const UPLOAD_SHEET_SETUP =
  BASE_BACKEND_URL + "/expense/sheet/upload/setup";
export const ALL_UPLOADED_SHEET =
  BASE_BACKEND_URL + "/expense/sheet/upload/all";
export const SINGLE_UPLOADED_SHEET =
  BASE_BACKEND_URL + "/expense/sheet/upload/";
export const EXPENSE_MONTHLY_GENERATED_SHEET =
  BASE_BACKEND_URL + "/expense/sheet/monthly-generated/all";

// Cylinder Module API
export const REGISTERED_CYLINDER = BASE_BACKEND_URL + "/cylinder";
export const ALL_CYLINDER = BASE_BACKEND_URL + "/cylinder/all";
export const CYLINDER_STATE = BASE_BACKEND_URL + "/cylinder/state";
export const DOWNLOAD_TEMPLATED = BASE_BACKEND_URL + "/cylinder/bulk-template";
export const UPLOAD_CYLINDER_BULK_SHEET = BASE_BACKEND_URL + "/cylinder/bulk";
export const DISPATCH_CYLINDER =
  BASE_BACKEND_URL + "/cylinder/dispatch/V2";
export const RECEIVE_CYLINDER_SETUP =
  BASE_BACKEND_URL + "/cylinder/receive/setup";
export const RECEIVE_CYLINDER = BASE_BACKEND_URL + "/cylinder/receive";
export const All_STATION_NAME = BASE_BACKEND_URL + "/station/all/name";
export const CHECK_CYLINDER = BASE_BACKEND_URL + "/cylinder/check";
export const SITE_CYLINDER_ALL =
  BASE_BACKEND_URL + "/cylinder/all/cylinderAndStation";
export const VEHICLE_SETUP = BASE_BACKEND_URL + "/cylinder/vehicle/setup";
export const RECEIVE_VEHICLE_SETUP =
  BASE_BACKEND_URL + "/cylinder/cylinders_on_vehicle";
export const ADD_VEHICLE = BASE_BACKEND_URL + "/cylinder/add_new_vehicle";
export const UPDATE_CYLINDER_SETUP =
  BASE_BACKEND_URL + "/cylinder/updateCylinderDetails/Setup";
export const UPDATE_CYLINDER =
  BASE_BACKEND_URL + "/cylinder/updateCylinderDetails";
export const CYLINDER_HISTORY = BASE_BACKEND_URL + "/cylinder/cylinderHistory/";
export const VEHICLE_HISTORY = BASE_BACKEND_URL + "/cylinder/vehicleHistory/";
export const EDIT_CYLINDER_SERIAL =
  BASE_BACKEND_URL + "/cylinder/update/serial-number";
export const CYLINDER_OPERATION = BASE_BACKEND_URL + "/cylinder/operational"
export const CYLINDER_PREDICTION = BASE_BACKEND_URL + "/cylinder/stationCylinderPrediction"
export const OPERATIONAL_LOGS = BASE_BACKEND_URL + "/cylinder/operational-logs/";
export const DISCARDED_CYLINDERS = BASE_BACKEND_URL + "/cylinder/all/discarded" ;
export const ACTIVATE_CYLINDER = BASE_BACKEND_URL + "/cylinder/restore/"
export const CYLINDER_TRANSIT = BASE_BACKEND_URL + "/cylinder/intransit"

// Factory Module API
export const FACTORY_CYLINDER_SETUP =
  BASE_BACKEND_URL + "/factory/cylinder/setup";
export const START_JOB_CARD = BASE_BACKEND_URL + "/factory/startjobcard/";
export const FACTORY_SETUP = BASE_BACKEND_URL + "/factory/setup";
export const FACTORY_CHECKPOINT_UPDATE =
  BASE_BACKEND_URL + "/factory/checkpoint/update/";
export const JOB_CARD_HISTORY = BASE_BACKEND_URL + "/factory/jobcard/history/";
export const FACTORY_SETUP_INFORM = BASE_BACKEND_URL + "/factory/setup/infromedTo"
export const FACTORY_CHECKPOINT_INFORM = BASE_BACKEND_URL + "/factory/update/"
export const FACTORY_CHECKPOINT_INFORMED = BASE_BACKEND_URL + "/factory/setup/checkpointUpdateReview";
export const FACTORY_CHECKPOINT_UPDATE_REVIEW = BASE_BACKEND_URL + "/factory/checkpointUpdateReview";
export const FACTORY_CHECKPOINT_UPDATE_REVIEW_HISTORY = BASE_BACKEND_URL + "/factory/checkpointUpdateReview/reviewed/"